// https://html.mmt.com/htmls/projects/HTMLFrontendHub/baseProjects/TypeSystem/gi/index.html

/* NOTE: not using the @React_UI_Lib/GIFontStandard since it does not support the type script
 import Styles from '@React_UI_Lib/GIFontStandard';
*/

// Type - Family and Weight
var fwRegular = '400';
var fwMedium = '500';
var fwSemiBold = '600';
var fwBold = '700';
var fs32 = '32px';
var fs24 = '24px';
var fs22 = '22px';
var fs18 = '18px';
var fs16 = '16px';
var fs14 = '14px';
var fs12 = '12px';
var lhAuto = 'normal';
var getTextDesign = function getTextDesign(sizes) {
  if (sizes === void 0) {
    sizes = {};
  }
  var _sizes = sizes,
    _sizes$size = _sizes.size32,
    size32 = _sizes$size === void 0 ? fs32 : _sizes$size,
    _sizes$size2 = _sizes.size24,
    size24 = _sizes$size2 === void 0 ? fs24 : _sizes$size2,
    _sizes$size3 = _sizes.size22,
    size22 = _sizes$size3 === void 0 ? fs22 : _sizes$size3,
    _sizes$size4 = _sizes.size18,
    size18 = _sizes$size4 === void 0 ? fs18 : _sizes$size4,
    _sizes$size5 = _sizes.size16,
    size16 = _sizes$size5 === void 0 ? fs16 : _sizes$size5,
    _sizes$size6 = _sizes.size14,
    size14 = _sizes$size6 === void 0 ? fs14 : _sizes$size6,
    _sizes$size7 = _sizes.size12,
    size12 = _sizes$size7 === void 0 ? fs12 : _sizes$size7;
  //  Lable
  var textSizes = {
    LargeW1: {
      'font-weight': fwRegular,
      'font-size': size18,
      'line-height': lhAuto
    },
    LargeW2: {
      'line-height': lhAuto,
      'font-size': size18,
      'font-weight': fwMedium
    },
    LargeW3: {
      'line-height': lhAuto,
      'font-size': size18,
      'font-weight': fwSemiBold
    },
    MediumW1: {
      'line-height': lhAuto,
      'font-size': size16,
      'font-weight': fwRegular
    },
    MediumW2: {
      'line-height': lhAuto,
      'font-size': size16,
      'font-weight': fwMedium
    },
    MediumW3: {
      'line-height': lhAuto,
      'font-size': size16,
      'font-weight': fwSemiBold
    },
    BaseW1: {
      'line-height': lhAuto,
      'font-size': size14,
      'font-weight': fwRegular
    },
    BaseW2: {
      'line-height': lhAuto,
      'font-size': size14,
      'font-weight': fwMedium
    },
    BaseW3: {
      'line-height': lhAuto,
      'font-size': size14,
      'font-weight': fwSemiBold
    },
    SmallW1: {
      'line-height': lhAuto,
      'font-size': size12,
      'font-weight': fwRegular
    },
    SmallW2: {
      'line-height': lhAuto,
      'font-size': size12,
      'font-weight': fwMedium
    },
    SmallW3: {
      'line-height': lhAuto,
      'font-size': size12,
      'font-weight': fwSemiBold
    }
  };

  //  Lable
  var headingSizes = {
    xLarge: {
      'font-weight': fwBold,
      'font-size': size32,
      'line-height': lhAuto
    },
    Large: {
      'line-height': lhAuto,
      'font-size': size24,
      'font-weight': fwBold
    },
    MediumW1: {
      'line-height': lhAuto,
      'font-size': size22,
      'font-weight': fwSemiBold
    },
    Small: {
      'line-height': lhAuto,
      'font-size': size18,
      'font-weight': fwSemiBold
    },
    Base: {
      'line-height': lhAuto,
      'font-size': size16,
      'font-weight': fwSemiBold
    }
  };
  return {
    textSizes: textSizes,
    headingSizes: headingSizes
  };
};
var _getTextDesign = getTextDesign(),
  textSizes = _getTextDesign.textSizes,
  headingSizes = _getTextDesign.headingSizes;
var _getTextDesign2 = getTextDesign({
    size32: 'calc(2.2857rem + var(--font-size-increment, 0px))',
    size24: 'calc(1.7143rem + var(--font-size-increment, 0px))',
    size22: 'calc(1.5714rem + var(--font-size-increment, 0px))',
    size18: 'calc(1.2857rem + var(--font-size-increment, 0px))',
    size16: 'calc(1.1429rem + var(--font-size-increment, 0px))',
    size14: 'calc(1rem + var(--font-size-increment, 0px))',
    size12: 'calc(0.8571rem + var(--font-size-increment, 0px))'
  }),
  scaleableTextSized = _getTextDesign2.textSizes,
  scaleableHeadingSizes = _getTextDesign2.headingSizes;
var fontScaleFactorStyle = function fontScaleFactorStyle(scaleFactor) {
  if (scaleFactor === void 0) {
    scaleFactor = '1';
  }
  var fontSize = 14 * Number(scaleFactor);
  return "<style>html{font-size:" + fontSize + "px;}</style>";
};
var fontScaleIncrementStyle = function fontScaleIncrementStyle(incrementValue) {
  if (incrementValue) {
    return "<style>:root {--font-size-increment:" + incrementValue + "px;}</style>";
  }
  return "";
};

export { scaleableHeadingSizes as a, fontScaleIncrementStyle as b, fontScaleFactorStyle as f, headingSizes as h, scaleableTextSized as s, textSizes as t };
